import './CompanyDetailsComponent.scss';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/AppReducer';
import { UserActions } from '../../../redux/UserActions';
import { AppActions } from '../../../redux/AppActions';
import { CompanyDetailsLoadingComponent } from './company-details-loading/CompanyDetailsLoadingComponent';
import { useAppDispatch } from '../../../redux/store';

const CompanyDetailsComponent: FC = () => {
	const dispatch = useAppDispatch();
	const hasCreatedBeaconProfile = useSelector(
		({ appState: state }: RootState) => state.hasCreatedBeaconProfile || false
	);
	const createBeaconProfileProgress = useSelector(
		({ appState: state }: RootState) => state.createBeaconProfileProgress || 0
	);
	const beaconProfileStartProgress = () => dispatch(AppActions.startBeaconProfileProgress());
	const beaconProfileEndProgress = () => dispatch(AppActions.finishBeaconProfileProgress());
	const setIsCompanyLoading = (isLoading: boolean) =>
		dispatch(AppActions.isCompanyLoading(isLoading));
	useEffect(() => {
		beaconProfileStartProgress();
		dispatch({ type: UserActions.GET_AUDIENCE_REGISTRATION });
	}, []);
	return (
		<div data-testid='company-details-container' className='company-details-container'>
			<CompanyDetailsLoadingComponent
				hasCreatedBeaconProfile={hasCreatedBeaconProfile}
				createBeaconProfileProgress={createBeaconProfileProgress}
				onProgressComplete={beaconProfileEndProgress}
				setIsCompanyLoading={setIsCompanyLoading}
			/>
		</div>
	);
};

export default CompanyDetailsComponent;
